

export class UserGroupSelectOutput implements IUserGroupSelectOutput {
    /** The auto-generated id of the user group master */
    user_group_id!: number;
    /** The user group name with 255 character limit */
    user_group_name!: string;
    /** The user type name with 255 character limit */
    user_type_name!: string;
    /** The company name with 255 character limit */
    company_name!: string;
    /** The application module with 255 character limit */
    application_module_name!: string;
    status!: number;

    constructor(data?: IUserGroupSelectOutput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.user_group_id = _data["user_group_id"];
            this.user_group_name = _data["user_group_name"];
            this.user_type_name = _data["user_type_name"];
            this.company_name = _data["company_name"];
            this.application_module_name = _data["application_module_name"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): UserGroupSelectOutput {
        data = typeof data === 'object' ? data : {};
        let result = new UserGroupSelectOutput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["user_group_id"] = this.user_group_id;
        data["user_group_name"] = this.user_group_name;
        data["user_type_name"] = this.user_type_name;
        data["company_name"] = this.company_name;
        data["application_module_name"] = this.application_module_name;
        data["status"] = this.status;
        return data; 
    }
}

export interface IUserGroupSelectOutput {
    /** The auto-generated id of the user group master */
    user_group_id: number;
    /** The user group name with 255 character limit */
    user_group_name: string;
    /** The user type name with 255 character limit */
    user_type_name: string;
    /** The company name with 255 character limit */
    company_name: string;
    /** The application module with 255 character limit */
    application_module_name: string;
    status: number;
}

